import axios from 'axios'
import Utils from '@/common/utils'

const url = `${process.env.VUE_APP_BASE_API}/api`
const headers = { Authorization: Utils.setLocalToken() }

export default class SurveyService {
  static async getForUser (userId) {
    const { data } = await axios.get(`${url}/survey-answer/getForUser/${userId}`, { headers })
    return data
  }

  static async saveAnswers (answers) {
    const { data } = await axios.post(`${url}/survey-answer/save/`, answers, { headers })
    return data
  }
}
